import { render, staticRenderFns } from "./HKLDescriptionPencilInput.vue?vue&type=template&id=1912a985&scoped=true&"
import script from "./HKLDescriptionPencilInput.vue?vue&type=script&lang=js&"
export * from "./HKLDescriptionPencilInput.vue?vue&type=script&lang=js&"
import style0 from "./HKLDescriptionPencilInput.vue?vue&type=style&index=0&id=1912a985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1912a985",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1912a985')) {
      api.createRecord('1912a985', component.options)
    } else {
      api.reload('1912a985', component.options)
    }
    module.hot.accept("./HKLDescriptionPencilInput.vue?vue&type=template&id=1912a985&scoped=true&", function () {
      api.rerender('1912a985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Input/HKLDescriptionPencilInput.vue"
export default component.exports